export const AGY_CLI_VERSION = '1.3.2';
